var React = require('react');

function CloseIconInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M39.5 20.9407C39.5 32.2517 30.7481 41.3814 20 41.3814C9.25186 41.3814 0.5 32.2517 0.5 20.9407C0.5 9.6297 9.25186 0.5 20 0.5C30.7481 0.5 39.5 9.6297 39.5 20.9407Z","stroke":"#BDBDBD","key":0}),React.createElement("path",{"d":"M26.6666 13.9605L13.651 27.9209M26.349 27.9209L13.3333 13.9605","stroke":"#BDBDBD","strokeWidth":"2","key":1})]);
}

CloseIconInline.defaultProps = {"width":"40","height":"42","viewBox":"0 0 40 42","fill":"none"};

module.exports = CloseIconInline;

CloseIconInline.default = CloseIconInline;
